import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import RouterContext from "../../context/RouterContext";
import {updateSeduta} from "../meeting/Utils";
import {properties} from "../../utils/properties";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    List,
    ListItem,
    ListItemText,
    Box,
    Stack,
  } from "@mui/material";
  import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function AuditSeduta() {
    //const [auditSeduta, setTopicList] = useState([]);
    const [auditSeduta, setAuditSeduta] = useState([]);
    const [groupedData,setGroupedData]=useState([]);
    //const [keyTopicList, setKeyTopicList] = useState([]);
    const navigate = useNavigate();
    let { meetingId } = useParams();
    let { organo } = useParams();
    const { pageRouter, setPageRouter } = useContext(RouterContext);
    //const meetingId = "20250121";
    //const organo = "Comitato di Gestione" ;

    function formattaData(data) {
        if (!/^\d{8}$/.test(data)) {
          return "Data non valida";
        }
        const anno = data.substring(0, 4);
        const mese = data.substring(4, 6);
        const giorno = data.substring(6, 8);
        return `${giorno}/${mese}/${anno}`;
      }

    const levelColors = [
        "#ffffff", // Livello 1: tipologia_documento
        "#ffffff", // Livello 2: sezione_seduta
        "#ffffff", // Livello 3: label_file
        "#EDEFEF", // Livello 4: ruolo (grigio chiaro, meno contrasto col resto)
      ];
    const getLevelColor = (depth) => levelColors[depth] || "#ffffff";

      function raggruppaDati(jsonData) {
        return jsonData.reduce((acc, item) => {
          const { tipologia_documento, sezione_seduta, label_file, ruolo, utente, data, ora, file } = item;

          // Usa una chiave unica combinando id e label_file
          const uniqueFileKey = `${label_file}#${file}`;

          if (!acc[tipologia_documento]) acc[tipologia_documento] = {};
          if (!acc[tipologia_documento][sezione_seduta]) acc[tipologia_documento][sezione_seduta] = {};
          if (!acc[tipologia_documento][sezione_seduta][uniqueFileKey]) acc[tipologia_documento][sezione_seduta][uniqueFileKey] = {};
          if (!acc[tipologia_documento][sezione_seduta][uniqueFileKey][ruolo]) acc[tipologia_documento][sezione_seduta][uniqueFileKey][ruolo] = [];

          acc[tipologia_documento][sezione_seduta][uniqueFileKey][ruolo].push({ utente, data, ora });
          return acc;
        }, {});
    }


     function calcolaTotaleAccessi(livello) {
        //if (Array.isArray(livello)) return livello.length;
        //return Object.values(livello).reduce((tot, sub) => tot + calcolaTotaleAccessi(sub), 0);
        if (Array.isArray(livello)) {
            return livello.filter(entry =>
                entry.utente && entry.data
            ).length;
        }
        return Object.values(livello).reduce((tot, sub) => tot + calcolaTotaleAccessi(sub), 0);
    }




    function convertiRuolo(ruolo) {
        if(ruolo==1)
            return "Presidente e Segretario Generale";
        else if(ruolo==2)
            return "Membri Comitato di Gestione";
        else if(ruolo==12)
            return "Segreteria degli Organi";
        else if(ruolo==20)
            return "Membri Consiglio Generale";
        else if(ruolo==21)
            return "Membri Collegio dei Revisori";
        else if(ruolo==4)
            return "Officer Fondazione";
        else if(ruolo==5)
            return "Amministrazione Attività Istituzionale";
        else if(ruolo==9 ||ruolo==11||ruolo==14)
            return "Personale Investimenti";
        else if(ruolo==10)
            return "Personale Controllo Periodico";
        else if(ruolo==13)
            return "Supporto Operations";
        else if(ruolo=="null")
            return "Nessun Accesso";
        else
            return ruolo;
    }

    function convertiTipo(tipo) {
        if(tipo=="ODG")
            return "Comitato di Gestione: Punti Ordine del Giorno";
        else if(tipo=="ODG_CONSIGLIO")
            return "Consiglio Generale: Punti Ordine del Giorno";
        else if(tipo=="ODG_COLLEGIO")
            return "Collegio Sindacale: Punti Ordine del Giorno";
        else if(tipo=="ODG_CG_PIANETA")
            return "Commissione Pianeta: Punti Ordine del Giorno";
        else if(tipo=="ODG_CG_PERSONE")
            return "Commissione Persone: Punti Ordine del Giorno";
        else if(tipo=="ODG_CG_CULTURA")
            return "Commissione Cultura: Punti Ordine del Giorno";
        else if(tipo=="ODG_CG_FINANZA")
            return "Commissione Finanza: Punti Ordine del Giorno";
        else if(tipo=="PREMESSE")
            return "Comitato di Gestione: Documenti Attività Istituzionale";
        else if(tipo=="ALLEGATI")
            return "Comitato di Gestione: Documenti allegati alle pratiche";
        else
            return tipo;
    }

    function convertiSezione(sezione) {
        if(sezione=="hidden")
            return "Comitato di Gestione: Convocazione";
        else if(sezione=="hidden_consiglio")
            return "Consiglio Generale: Convocazione";
        else if(sezione=="controlliperiodici")
            return "Comitato di Gestione: Controlli Periodici";
        else if(sezione=="default")
            return "Comitato di Gestione: Altri Punti";
        else if(sezione=="consiglio_default")
            return "Consiglio Generale: Punti all'Ordine del Giorno";
        else if(sezione=="cgpianeta_default")
            return "Commissione Pianeta: Punti all'Ordine del Giorno";
        else if(sezione=="cgpersone_default")
            return "Commissione Persone: Punti all'Ordine del Giorno";
        else if(sezione=="cgcultura_default")
            return "Commissione Cultura: Punti all'Ordine del Giorno";
        else if(sezione=="cgfinanza_default")
            return "Commissione Finanza: Punti all'Ordine del Giorno";
        else if(sezione=="collegio_default")
            return "Collegio Sindacale: Punti all'Ordine del Giorno";
        else if(sezione=="verbali")
            return "Comitato di Gestione: Verbali";
        else if(sezione=="personale")
            return "Comitato di Gestione: Personale";
        else if(sezione=="investimentipatrimoniali")
            return "Comitato di Gestione: Investimenti Patrimoniali";
        else if(sezione=="attivitaistituzionale")
            return "Comitato di Gestione: Attività Istituzionale";
        else
            return sezione;
    }

    function aggiornaCoerenza(entries) {
        return entries.map(entry => {
            console.log(entry, entry.utente);
            if (entry.utente != undefined) {
                if (entry.utente.toLowerCase() === 'ventrella') {
                    return { ...entry, ruolo: 2 };
                }
                if (entry.utente.toLowerCase() === 'testfinanza'||entry.utente.toLowerCase()=== 'dio'||entry.utente.toLowerCase().endsWith("25")) {
                    return null;
                }
            }
          return entry;
        }).filter(entry => entry !== null);
        /*.filter (entry => {
            return !(entry.utente && entry.utente.toLowerCase() === 'testfinanza' || entry.utente && entry.utente.endsWith("25"));
          });        */
      }

    const updateUI = function(auditData) {
        console.log("UPDATEUI",auditData);
        auditData=aggiornaCoerenza(auditData);
        console.log("UPDATEUI",auditData);
        setAuditSeduta(auditData);
        setGroupedData(raggruppaDati(auditData));



      //const topicList = Object.entries(meetingData)[6][1];
      //const valueTopicList = Object.values(topicList);
      //const keyTopicList = Object.keys(topicList);
      //setTopicList(valueTopicList);
      //setKeyTopicList(keyTopicList);
    }

    const doPostGetAudit = function() {
        if( properties.verboseLog==1)
            console.log("doing sedute post");
        var xhr2 = new XMLHttpRequest();
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/getAudit.php',true);

        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr2.withCredentials = true;
        xhr2.onload = function (e) {
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;
                    var obj=JSON.parse(responseText);
                    //setAuditSeduta(obj);
                    //if( properties.verboseLog==1)
                    console.log("OK93",obj);
                    updateUI(obj);
                }
                else {
                    console.error("Error 15", xhr2.statusText);
                    window.alert("Errore recuperando la seduta 9");
                    navigate("/init",{ replace: true });
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 25", xhr2.statusText);
        };

        //let urlEncodedData = "organo=Comitato" + "&data=20250121";
        //let urlEncodedData = "organo=Comitato" + "&data=20250220";
        let urlEncodedData = "organo="+organo + "&data="+meetingId;

        //if( properties.verboseLog==1)
            console.log("AUDITSEDUTA",urlEncodedData);
        xhr2.send(urlEncodedData);
}

function convertiLabel(organo) {
    if(organo=="Comitato")
        return "Comitato di Gestione";
    else if(organo=="Collegio")
        return "Collegio Sindacale";
    else if(organo=="Consiglio")
        return "Consiglio Generale";
    else if(organo=="CG_PIANETA")
        return "Commssione Pianeta";
    else if(organo=="CG_CULTURA")
        return "Commssione Cultura";
    else if(organo=="CG_PERSONE")
        return "Commssione Persone";
    else if(organo=="CG_FINANZA")
        return "Commssione Finanza";
    return organo;
}


    useEffect(() => {
        if(!window.cordova){
        //CHECK AUTHENTICATION
        var xhr = new XMLHttpRequest();
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/ping.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    if( properties.verboseLog==1)
                        console.log("OK",xhr);
                    doPostGetAudit();
                } else {
                    console.error("Error 5", xhr);
                    localStorage.clear();
                    navigate("/login");
                }
            }
        };

        xhr.onerror = function (e) {
          console.error("Error 75", xhr);
          localStorage.clear();
          navigate("/login");
        };

        let urlEncodedData = null;
        xhr.send(urlEncodedData);
        //CHECK AUTHENTICATION
        }

        if (window.cordova){
            doPostGetAudit();
        }
    }, []);


    function convertiOrganoInColore(organo) {
        if(organo=="Comitato")
            return "#30720f";
        else if(organo=="Consiglio")
            return "#BF360C";
        else if(organo=="Collegio")
            return "#666999";
        else if(organo=="CG_PIANETA")
            return "#008FD1";
        else if(organo=="CG_PERSONE")
            return "#F0B323";
        else if(organo=="CG_CULTURA")
            return "#ce0f69";
        else if(organo=="CG_FINANZA")
            return "#046A38";
        else
            return "#000000";
    }



    return (
        <div className="audit-detail-page" style={{ background: "#f5f5f5",
        padding: "30px 5%",
        minHeight:"100vh",
        }}>
        <Typography variant="h5" align="left" className="audit-detail-title" sx={{paddingBottom:"10px", paddingLeft:"10px"}}>
        {convertiLabel(organo) + " - Seduta del "+ formattaData(meetingId)+ ": Statistiche di accesso al materiale caricato"}
        </Typography>
         <Box>
      {Object.entries(groupedData).map(([tipo, sezioni]) => (
        <Accordion
          key={tipo}
          className="audit-detail-l1"
          disableGutters
          square
          elevation={0}
          TransitionProps={{ style: { width: "100%" } }}
          slotProps={{ transition: { style: { width: "100%" } } }}
          sx={{ backgroundColor: levelColors[0], mb: 1, width: "100%", boxSizing: "border-box",  borderRadius: "10px",borderBottomRightRadius: "8px", borderTopRightRadius: "8px",
        borderRightColor:convertiOrganoInColore(organo),borderRightWidth: { xs: "6px", sm: "10px" },borderRightStyle:"solid" }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className="audit-detail-summary">
            <Typography variant="subtitle1" fontWeight="bold" className="audit-detail-label">
              {convertiTipo(tipo)} ({calcolaTotaleAccessi(sezioni) + " accessi"})
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pl: { xs: 0.75, sm: 2 }, pr: { xs: 0.5, sm: 2 }, borderLeft: { xs: "2px solid #e0e0e0", sm: "none" } }}>
            {Object.entries(sezioni).map(([sezione, files]) => (
              <Accordion
                key={sezione}
                disableGutters
                square
                elevation={0}
          TransitionProps={{ style: { width: "100%" } }}
          slotProps={{ transition: { style: { width: "100%" } } }}
                sx={{ backgroundColor: levelColors[1], mb: 1, width: "100%", boxSizing: "border-box" }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className="audit-detail-summary">
                  <Typography variant="subtitle1" fontWeight="medium" className="audit-detail-label">
                    {convertiSezione(sezione)} ({calcolaTotaleAccessi(files)+ " accessi"})
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ pl: { xs: 0.75, sm: 2 }, pr: { xs: 0.5, sm: 2 }, borderLeft: { xs: "2px solid #e0e0e0", sm: "none" } }}>
                  {Object.entries(files).map(([file, ruoli]) => (
                    <Accordion
                      key={file}
                      disableGutters
                      square
                      elevation={0}
          TransitionProps={{ style: { width: "100%" } }}
          slotProps={{ transition: { style: { width: "100%" } } }}
                      sx={{ backgroundColor: levelColors[2], mb: 1, width: "100%", boxSizing: "border-box" }}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="audit-detail-summary">
                        <Typography variant="body1" fontWeight="medium" className="audit-detail-label">
                          {file.substring(0,file.indexOf("#"))} ({calcolaTotaleAccessi(ruoli)+ " accessi"})
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ pl: { xs: 0.75, sm: 2 }, pr: { xs: 0.5, sm: 2 }, borderLeft: { xs: "2px solid #e0e0e0", sm: "none" } }}>
                        {Object.entries(ruoli).map(([ruolo, accessi]) => (
                          <Accordion
                            key={ruolo}
                            disableGutters
                            square
                            elevation={0}
          TransitionProps={{ style: { width: "100%" } }}
          slotProps={{ transition: { style: { width: "100%" } } }}
                            sx={{ backgroundColor: levelColors[3], mb: 1, width: "100%", boxSizing: "border-box", borderRadius: "10px", }}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className="audit-detail-summary">
                              <Typography variant="body1" className="audit-detail-label">
                                {convertiRuolo(ruolo)} {ruolo != "null" &&  "(" + accessi.length + " " + (accessi.length === 1 ? "accesso" : "accessi") + ")"}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ pl: { xs: 0.75, sm: 2 }, pr: { xs: 0.5, sm: 2 }, borderLeft: { xs: "2px solid #e0e0e0", sm: "none" } }}>
                              {accessi.map((entry, i) => (
                                  <Box key={i} className="audit-detail-entry">
                                     <Box component="span" className="audit-detail-entry-user">{(entry.utente||"Nessun accesso").toUpperCase()}</Box>
                                     {entry.utente != null && (
                                        <Box component="span" className="audit-detail-entry-meta">
                                            {formattaData(entry.data)} {entry.ora}
                                        </Box>
                                     )}
                                </Box>
                              ))}
                            </AccordionDetails>
                          </Accordion>
                        ))}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
        </div>
    );
}
